var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "HazmatAuthorizationSites", attrs: { fluid: "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "", "justify-space-between": "" } },
        [
          _c(
            "v-flex",
            { attrs: { md3: "" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  items: _vm.allWarehousesOptions,
                  label: _vm.$t("warehouse")
                },
                model: {
                  value: _vm.hazmatWarehouse,
                  callback: function($$v) {
                    _vm.hazmatWarehouse = $$v
                  },
                  expression: "hazmatWarehouse"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { md4: "" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", dark: "" },
                  on: { click: _vm.addAuthorizationSites }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("addAuthorizationSites")) +
                      "\n      "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-flex", { attrs: { md4: "" } })
        ],
        1
      ),
      _vm._v(" "),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.hazmatSitesTable,
          "hide-actions": "",
          pagination: _vm.pagination,
          "rows-per-page-items": _vm.rowPerPage,
          "item-key": "key"
        },
        on: {
          "update:pagination": function($event) {
            _vm.pagination = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function(props) {
              return [
                _c(
                  "td",
                  { staticClass: "text-xs-left" },
                  [
                    _c(
                      "v-layout",
                      [
                        _c("v-flex", [
                          _vm._v(
                            _vm._s(_vm.$t("siteName")) +
                              ": " +
                              _vm._s(props.item.siteName)
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      [
                        _c("v-flex", [
                          _vm._v(
                            _vm._s(_vm.$t("warehouse")) +
                              ": " +
                              _vm._s(props.item.warehouseName)
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(_vm._s(props.item.authorizationId))
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.abbrevToStates[props.item.state] || props.item.state
                      ) +
                      "\n        " +
                      _vm._s(props.item.city) +
                      "\n        " +
                      _vm._s(props.item.address1 || "") +
                      "\n        " +
                      _vm._s(props.item.address2 || "") +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(
                    _vm._s(props.item.contact) + "/" + _vm._s(props.item.phone)
                  )
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-center" },
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "" } },
                      [
                        _c(
                          "v-flex",
                          [
                            _c("LoaderButton", {
                              attrs: {
                                flat: "",
                                promiseAwait: _vm.updateAuthorizationSites,
                                promiseItem: props.item
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "icon",
                                    fn: function() {
                                      return [_c("v-icon", [_vm._v("refresh")])]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { dark: "", flat: "", color: "primary" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.deleteAuthorizationSites(
                                      props.item
                                    )
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("delete")])],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _vm.sitesModel.show
        ? _c("FormSubmitPopup", {
            ref: "form",
            attrs: {
              title: _vm.$t("addAuthorizationSites"),
              rightMethod: _vm.submit,
              rightButtonText: _vm.$t("add"),
              rightButtonLoading: _vm.sitesModel.loading,
              leftMethod: function() {
                return (_vm.sitesModel.show = false)
              },
              hasAlert: "",
              medium: ""
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            "justify-space-between": "",
                            "align-baseline": ""
                          }
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md4: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.warehousesOptions,
                                  label: _vm.$t("warehouse"),
                                  rules: [_vm.fieldIsRequired("warehouse")]
                                },
                                on: { change: _vm.getSitesOptions },
                                model: {
                                  value: _vm.sitesModel.warehouseKey,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.sitesModel,
                                      "warehouseKey",
                                      $$v
                                    )
                                  },
                                  expression: "sitesModel.warehouseKey"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md5: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.sitesModel.sitesOptions,
                                  label: _vm.$t("warehouseSite"),
                                  rules: [_vm.fieldIsRequired("warehouse site")]
                                },
                                model: {
                                  value: _vm.sitesModel.siteKey,
                                  callback: function($$v) {
                                    _vm.$set(_vm.sitesModel, "siteKey", $$v)
                                  },
                                  expression: "sitesModel.siteKey"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t("authorizationId"),
                                  rules: [
                                    _vm.fieldIsRequired("authorization id")
                                  ]
                                },
                                model: {
                                  value: _vm.sitesModel.authorizationId,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.sitesModel,
                                      "authorizationId",
                                      $$v
                                    )
                                  },
                                  expression: "sitesModel.authorizationId"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              1521698779
            ),
            model: {
              value: _vm.sitesModel.show,
              callback: function($$v) {
                _vm.$set(_vm.sitesModel, "show", $$v)
              },
              expression: "sitesModel.show"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b266c7c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b266c7c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HazmatAuthorizationSites.vue
// module id = null
// module chunks = 